import { QueryKey, useQuery, UseQueryOptions } from 'react-query'
import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

export const hotspotsQueryKey = (imageUrl: string): QueryKey => ['hotspots', imageUrl]

export type Hotspot = {
  x: number
  y: number
  width: number
  height: number
  subject_type: 'text_box' | 'image' | 'call_to_action' | 'logo'
  description: string
}

const fetchHotspots = async (imageUrl: string) => {
  const res = await sendToApi<Hotspot[]>('/hotspots', {
    method: 'POST',
    body: {
      image_url: imageUrl,
    },
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error('Hotspots request failed')
  }

  return res.data
}

export const useHotspots = (
  imageUrl: string,
  options?: Omit<UseQueryOptions<Hotspot[], Error>, 'queryKey' | 'queryFn'>,
) => {
  const hotspotsAllSubjectTypes = useFlipperFlag('hotspots_all_subject_types')
  const { select: userSelect, ...restOptions } = options ?? {}

  return useQuery<Hotspot[], Error>(hotspotsQueryKey(imageUrl), () => fetchHotspots(imageUrl), {
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    ...restOptions,
    select: (data) => {
      const filtered = hotspotsAllSubjectTypes
        ? data
        : data.filter((h) => h.subject_type === 'text_box')
      return userSelect ? userSelect(filtered) : filtered
    },
  })
}
